import { PartnerAnalysisGroup2 } from '../../entities/control-tables/partner-analysis-group2';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';

export class PartnerAnalysisGroup2Request extends BaseRequest {

    partnerAnalysisGroup2 : PartnerAnalysisGroup2

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.partnerAnalysisGroup2 = new PartnerAnalysisGroup2()
  }
}